// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__339QC","productName":"Table_productName__2jERk"};